import { beApi, feApi } from "@/app/api/utils/api";
import { ApiResponse } from "@/types";

/**
 *  Get a token from the frontend API
 *
 */
export async function getTokenFromFE(): Promise<string> {
  try {
    const res = (await feApi
      .options({
        next: {
          // 24 hours
          revalidate: 86400,
        },
      })
      .get("/token")) as ApiResponse<string>;

    return res?.data;
  } catch (error) {
    console.log(error);

    return "";
  }
}

type Res = {
  data: {
    token: string;
    expiryDate: string;
  };
};

/**
 *  Generate a token from the backend API directly
 *
 */
export async function getTokenFromBE(): Promise<string> {
  try {
    const res = (await beApi
      .options({
        next: {
          // 24 hours
          revalidate: 86400,
        },
      })
      .get("/token/rand12")) as Res;

    return res?.data?.token;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.log("Error generating token", error);
    console.log("BACKEND_API_URL", process.env.BACKEND_URL);
    console.error(error);

    return "";
  }
}
